import { AutoManagedReport } from '@anytag/shared-organisms';
import { useAutoManagedCampaignDetailsContext } from '../auto-managed-campaign-details-context';

export const AutoManagedCampaignReport = () => {
  const { autoManagedCampaign } = useAutoManagedCampaignDetailsContext();

  return <AutoManagedReport autoManagedCampaign={autoManagedCampaign} />;
};
